module.exports = __webpack_public_path__ + "img/arrow-right.e5e9394b.svg";